import React from "react";
import styled from "styled-components";
import {useTranslation} from 'gatsby-plugin-react-i18next';

const CopyLink = styled.div`
  color: var(--bs-white);
  a{
    color: inherit;
    text-decoration: none;
    &:hover {
      color: var(--bs-lime-green);
    }
  }
`

const SnigCopy = () => {
  const {t} = useTranslation();

  return (
    <CopyLink className="fw-700 fs-14 letter-spacing-n015 lh-125 d-inline-flex gap-6 align-items-center" >
      <span>
        Code by <a href="https://alexcss.com/" target="_blank" rel="noopener noreferrer">Oleksii Kaliuzhnyi</a>.
      </span>
      <span className={`d-inline-flex gap-6 align-items-center`}>
        Design by
        <a href="https://www.snig.digital/" target="_blank" rel="noopener noreferrer" title={`Snig.digital`}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M7.98892 10.892L7.98899 9.09435L9.54257 8.19547L11.0961 9.09421L11.096 10.8918L9.54241 11.7907L7.98892 10.892Z" fill="currentColor"/>
            <path d="M19.083 13.4474L17.2891 16.5612L14.0586 14.6921C13.3123 14.2602 12.6913 13.6408 12.2572 12.8949L11.0979 10.9031L13.3988 10.9134C14.2604 10.9173 15.1062 11.1464 15.8525 11.5783L19.083 13.4474Z" fill="currentColor"/>
            <path d="M17.292 3.44698L19.0859 6.56078L15.8554 8.42989C15.1091 8.86171 14.2633 9.09089 13.4017 9.09473L11.1008 9.105L12.2601 7.11321C12.6942 6.36739 13.3152 5.74791 14.0615 5.31609L17.292 3.44698Z" fill="currentColor"/>
            <path d="M1.80371 16.5617L0.00979435 13.4479L3.24028 11.5788C3.98662 11.147 4.83245 10.9178 5.69402 10.914L7.99495 10.9037L6.83561 12.8955C6.4015 13.6413 5.78054 14.2608 5.0342 14.6926L1.80371 16.5617Z" fill="currentColor"/>
            <path d="M0 6.55899L1.79392 3.44519L5.0244 5.3143C5.77074 5.74612 6.39171 6.36561 6.82582 7.11142L7.98515 9.10322L5.68422 9.09295C4.82265 9.0891 3.97683 8.85992 3.23049 8.4281L0 6.55899Z" fill="currentColor"/>
            <path d="M7.75684 0H11.3447V3.74399C11.3447 4.60393 11.1207 5.44905 10.6947 6.19608L9.55075 8.20225L8.40682 6.19608C7.98085 5.44905 7.75684 4.60393 7.75684 3.74399V0Z" fill="currentColor"/>
            <path d="M11.3389 20.0001L7.75103 20.0001L7.75103 16.2561C7.75103 15.3962 7.97505 14.551 8.40102 13.804L9.54495 11.7978L10.6889 13.804C11.1149 14.551 11.3389 15.3962 11.3389 16.2561L11.3389 20.0001Z" fill="currentColor"/>
          </svg>
        </a>
      </span>
    </CopyLink>
  );
}

export default SnigCopy
